import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import tw from "twin.macro"

import {Leading} from "./layout"
import AppLink from "./app-link"

const LDMSContainer = tw.div`flex flex-col md:flex-row items-center`
const LDMSImgContainer = tw.div`w-full md:w-1/2`
const LDMSImg = tw(Img)``
const LDMSBody = tw.div`flex-1`
const LDMSTitle = tw.h2`text-2xl md:text-3xl lg:text-4xl text-ql-blue leading-tight`
const LDMSContent = tw(Leading)`text-base md:text-xl`

const LDMSFeature = () => {
  const data = useStaticQuery(graphql`
    query {
      ldmsScreenshot: file(relativePath: { eq: "ldms-screenshot.png" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <LDMSContainer>
      <LDMSImgContainer>
        <LDMSImg fluid={data.ldmsScreenshot.childImageSharp.fluid} />
      </LDMSImgContainer>
      <LDMSBody>
        <LDMSTitle>Integration with <AppLink href="https://www.ldms.org">LDMS<sup>®</sup></AppLink></LDMSTitle>
        <LDMSContent>
          Labelscape provides out-of-box support for <AppLink href="https://www.ldms.org">LDMS</AppLink>, the laboratory data
          management system by Frontier Science. Save time by scanning barcodes
          from Labelscape to pre-populate quick add templates in LDMS.
        </LDMSContent>
      </LDMSBody>
    </LDMSContainer>
  )
}

export default LDMSFeature
